import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Loader2, Globe, Mail, Phone, BadgeCheck, ArrowLeft } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";

export default function SponsorDetail() {
  const { id } = useParams();
  const [s, setS] = useState(undefined);
  useEffect(() => {
    api.get(`/sponsors/${id}`).then((r) => setS(r.data)).catch(() => setS(null));
  }, [id]);

  if (s === undefined) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-orange-500" /></div>;
  if (s === null) return <div className="max-w-3xl mx-auto px-6 py-20 text-center text-slate-500">Partener negăsit. <Link to="/produse" className="text-orange-600 font-semibold">Vezi catalogul</Link></div>;

  return (
    <div className="bg-slate-950 text-white min-h-screen" data-testid="sponsor-detail-page">
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Link to="/produse" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-orange-500 transition-colors mb-8"><ArrowLeft className="w-4 h-4" /> Catalog</Link>
        <div className="flex items-center gap-2 mb-6">
          <span className="inline-flex items-center gap-1.5 bg-amber-500 text-slate-900 text-xs font-bold uppercase tracking-wide px-3 py-1"><BadgeCheck className="w-3.5 h-3.5" /> Partener oficial</span>
        </div>
        <div className="flex items-start gap-6 flex-wrap">
          {s.logo && <img src={mediaUrl(s.logo)} alt={s.company} className="h-20 object-contain" />}
          <div>
            <h1 className="text-3xl sm:text-4xl font-black tracking-tighter">{s.company}</h1>
            {s.brand && <div className="text-orange-500 font-bold uppercase tracking-wide mt-1">{s.brand}</div>}
          </div>
        </div>
        {s.description && <p className="text-slate-300 mt-6 leading-relaxed max-w-2xl">{s.description}</p>}
        {s.categories?.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-6">
            {s.categories.map((c) => <span key={c} className="text-xs font-semibold text-slate-300 border border-slate-700 px-3 py-1.5">{c}</span>)}
          </div>
        )}
        <div className="border-t border-slate-800 mt-8 pt-6 flex flex-wrap gap-6 text-sm">
          {s.website && <a href={s.website} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-slate-300 hover:text-orange-500"><Globe className="w-4 h-4" /> {s.website.replace(/^https?:\/\/(www\.)?/, "")}</a>}
          {s.contact_email && <a href={`mailto:${s.contact_email}`} className="inline-flex items-center gap-2 text-slate-300 hover:text-orange-500"><Mail className="w-4 h-4" /> {s.contact_email}</a>}
          {s.contact_phone && <a href={`tel:${s.contact_phone}`} className="inline-flex items-center gap-2 text-slate-300 hover:text-orange-500"><Phone className="w-4 h-4" /> {s.contact_phone}</a>}
        </div>
        <Link to={`/produse?search=${encodeURIComponent(s.brand || s.company)}`} className="inline-flex items-center gap-2 mt-8 bg-orange-600 hover:bg-orange-700 px-6 py-3 font-bold uppercase tracking-wide text-sm transition-colors" data-testid="sponsor-products-cta">
          Vezi produsele {s.brand || s.company}
        </Link>
      </div>
    </div>
  );
}
